import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Toggle from 'material-ui/Toggle'
import { toggleShowMmsFromUnknownNumbers } from '../../state/actions/account'

const styles = {
  containerStyle: {
    paddingRight: '30px',
  },
  labelStyle: {
    fontWeight: 'normal',
    textAlign: 'left',
  },
}
class ShowMmsFromUnknownToggle extends Component {
  static propTypes = {
    clickToggle: PropTypes.func,
    showMmsFromUnknownNumbers: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  handleToggle = () => {
    const { clickToggle, showMmsFromUnknownNumbers } = this.props
    clickToggle(showMmsFromUnknownNumbers)
  }

  render() {
    const { showMmsFromUnknownNumbers } = this.props

    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Toggle
          id="showMmsFromUnknownToggle"
          toggled={showMmsFromUnknownNumbers}
          label="Show images in texts from unknown senders"
          disabled={false}
          style={styles.containerStyle}
          labelStyle={styles.labelStyle}
          onToggle={this.handleToggle}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ account }) => ({
  showMmsFromUnknownNumbers: account.user.showMmsFromUnknownNumbers,
})

const mapDispatchToProps = dispatch => ({
  clickToggle: showMmsFromUnknownNumbers => dispatch(toggleShowMmsFromUnknownNumbers(showMmsFromUnknownNumbers)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowMmsFromUnknownToggle)



// WEBPACK FOOTER //
// ./src/components/Account/ShowMmsFromUnknownToggle.js